module.exports = __webpack_public_path__ + "img/checkItem.6ad127ee.svg";